import React from "react";
import c from "../../constant"
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    Text,
    ModalBody,
    ModalCloseButton,
    Button,
    Box,
    Flex
} from "@chakra-ui/react"
import { Formik, Form } from "formik";
import * as Yup from "yup";
import TextFormField from "../form/TextFormField";
import DateRangeFormField from "../form/DateRangeFormField";
import CheckBoxFormField from "../form/CheckBoxFormField";
import moment from "moment";
import { from } from "@apollo/client";
import { useTranslation } from "react-i18next";
import RadioFormField from "../form/RadioFormField";
import useStore from "../../store";

import 'moment/locale/en-gb';

const filterSchema = Yup.object().shape({
    number: Yup.number(),
    name: Yup.string(),
    type: Yup.string(),
    createdDate: Yup.string(),
    unreadOnly: Yup.boolean(),
});

function LeaveRequestFilter({ isOpen, onClose, callback ,
    status="",
    number="",
    name="",
    type="",
    fromDate=null,
    toDate=null,
    read=null,
}) {
    moment.locale("en-gb")
    const { t } = useTranslation();
    const { currentUser } = useStore((state) => state.currentUser);

    let defaultRange = ""
	if(fromDate&&toDate){
        const defaultFrom = JSON.parse(fromDate);

		const defaultTo = JSON.parse(toDate);
		defaultRange = {
			from: defaultFrom,
			to: defaultTo
		}
    }

    return (
        <>
            <Modal borderRadius={c.borderRadius} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent borderRadius={c.borderRadius}>
                    <ModalHeader>{t("Filter")}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Formik
                            initialValues={{
                                number: number?number:"",
                                name: name?name:"",
                                type: type?type:"",
                                createdDate: defaultRange?JSON.stringify(defaultRange):"",
                                unreadOnly: read?read:""
                            }}
                            validationSchema={filterSchema}
                            onSubmit={(values) => {
                                let url = "?page=1"
                                if(status){
                                    url+=`&status=${status}`
                                }
                                if(values.number){
                                    url+=`&number=${values.number}`
                                }
                                if(values.name){
                                    url+=`&name=${values.name}`
                                }
                                if(values.type){
                                    url+=`&type=${values.type}`
                                }
                                if(values.createdDate){
                                    const tmpDate = JSON.parse(values.createdDate)
                                    if(tmpDate?.from&&tmpDate?.to){
                                        const dateFrom = JSON.stringify(tmpDate.from)
                                        const dateTo = JSON.stringify(tmpDate.to)
                                        url+=`&fromDate=${dateFrom}&toDate=${dateTo}`
                                    }
                                }
                                if(values.unreadOnly){
                                    url+=`&read=false`
                                }
                                callback(url)
                                onClose()
                            }}
                        >
                            {(props) => (
                                <Box pb="4">
                                    <Form>
                                        <TextFormField
                                            {...props}
                                            label="Number"
                                            name="number"
                                            type="number"
                                        />
                                        <TextFormField
                                            {...props}
                                            label="Name"
                                            name="name"
                                        />
                                        <center>
                                        <DateRangeFormField
                                            {...props}
                                            label="Created Date"
                                            name="createdDate"
                                            initialDate={{fromDate,toDate}}
                                        />
                                        </center>

                                        <RadioFormField
                                            label="Type"
                                            name="type"
                                            radios={[
                                                {label:"Annual leave", value:"ANNUAL_LEAVE"},
                                                {label:"Short leave", value:"SHORT_LEAVE"},
                                                {label:"Maternity leave", value:"MATERNITY_LEAVE"},
                                                {label:"Sick leave", value:"SICK_LEAVE"},
                                                {label:"Personal leave", value:"PERSONAL_LEAVE"}
                                            ]}
                                            initValue={type}
                                        />
                                        
                                        <Box marginTop="4">
                                            <CheckBoxFormField
                                                {...props}
                                                label="Show unread only"
                                                name="unreadOnly"
                                            />
                                        </Box>

                                        <Flex mt="32px" justifyContent="flex-end">
                                            <Button
                                                id="login-btn"
                                                variant="solid"
                                                size="md"
                                                h="42px"
                                                w="128px"
                                                type="submit"
                                                borderRadius={c.borderRadius}
                                                color="#3498db"
                                            >
                                                {t("Apply")}
                                            </Button>
                                            <Button
                                                size="md"
                                                h="42px"
                                                ml={4}
                                                w="128px" onClick={() => {
                                                    callback('?page=1')
                                                    onClose()
                                                }} variant="ghost">{t("Clear")}</Button>
                                        </Flex>
                                    </Form>

                                </Box>
                            )}
                        </Formik>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}

export default LeaveRequestFilter